<script lang="ts" setup>
import { computed } from "vue";

import { OrderStopType } from "@/constants/order";
import { formatRouteAddress } from "@/utils/routes";

import type { InvoiceOrderStop } from "@/api/billing/dto/invoice";

const props = defineProps<{
  stops: InvoiceOrderStop[];
}>();

const address = computed<string | null>(() => {
  const sortedStops = [...props.stops].sort((a, b) => a.position - b.position);
  const firstPickup = sortedStops.find((stop) => stop.type === OrderStopType.pickup);
  const lastDelivery = sortedStops.findLast((stop) => stop.type === OrderStopType.delivery);

  return formatRouteAddress(firstPickup?.facilityAddress, lastDelivery?.facilityAddress);
});
</script>

<template>
  <span class="font-weight-500 text-grey-darken-3" data-qa="invoice-route">{{ address ?? "—" }}</span>
</template>
